import { Message } from '@/mocks/app/mockChatData';
import { resolveSelectableMessageIds } from './resolveSelectableMessageIds';

/**
 * Mensagens não lidas de uma conversa, a partir do contador do servidor.
 *
 * Não existe "lida" por mensagem recebida: o servidor manda só a QUANTIDADE
 * (`naoLidas`), e ela conta apenas o que veio do outro lado — o socket também só
 * incrementa `unreadCount` quando `!enviadaPorMim`. Então as não lidas são as
 * últimas `quantidade` mensagens RECEBIDAS, pulando as nossas que estejam no meio
 * (resposta de bot, envio de outro atendente). Contar as N últimas da lista, sem
 * olhar o remetente, punha o separador depois de mensagens ainda não lidas.
 *
 * Devolve menos que `quantidade` quando o que está carregado não alcança a
 * primeira não lida — é o sinal para buscar mais páginas.
 */
export function idsNaoLidas(mensagens: readonly Message[], quantidade: number): Set<string> {
    const ids = new Set<string>();
    for (let i = mensagens.length - 1; i >= 0 && ids.size < quantidade; i--) {
        if (!mensagens[i].isSent) ids.add(mensagens[i].id);
    }
    return ids;
}

/**
 * Item EXIBIDO antes do qual o separador entra: a primeira mensagem não lida, ou
 * a grade de mídias que a engoliu — a grade tem id sintético (`grid-<id>`) e nunca
 * casaria com o id cru. Mensagem filtrada da tela (genérica sem conteúdo) não
 * some com o separador: ele vai para a próxima não lida que aparece. Anotação
 * interna não é mensagem e não recebe separador.
 */
export function itemComPrimeiraNaoLida(itens: readonly Message[], ids: ReadonlySet<string>): string | null {
    if (ids.size === 0) return null;
    const item = itens.find(m => m.type !== 'internal-note' && resolveSelectableMessageIds(m).some(id => ids.has(id)));
    return item?.id ?? null;
}

export function rotuloNaoLidas(quantidade: number): string {
    return quantidade === 1 ? '1 mensagem não lida' : `${quantidade} mensagens não lidas`;
}
